//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// ----start----
// update： 2019/9/5 何定恒
// info：滚动器在滚动的时候，进行refresh操作后，onScrollEnd会被立即执行，哪怕滚动器这时候仍然在滚动。这就会导致onScrollEnd函数里获取到的信息不正常。
// reappear: 滚动年的同时滚动日，当年滚动停止而日仍然在滚动的时候，年的onScrollEnd里会执行日的refresh，导致日在滚动的时候执行onScrollEnd，而正常滚动结束后不会执行onScrollEnd。日获取到的信息就是滚动的时候的信息。
// fix：年月滚动可能会导致日的天数变化，所以年月变化后必须进行refresh，refresh执行导致onScrollEnd提前执行是补可避免的。但是我们可以避免在onScrollEnd里拿取信息。可以在用户点击“完成”按钮的时候，在sure方法（进行了滚动判断，确保滚动器都停止后才会继续）里访问滚动器实例拿取最终的滚动信息。
// Todo：目前测试只有日容易出现这个问题，仅对日进行了修复。年月未复现出来该问题。
// ----end----

import calendar from "./calendar.js";
import IScroll from "./iscroll2.js";

export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    defaultdate: {
      type: String
    },
    defaulthour: {
      type: String
    },
    defaultwhich: {
      type: String
    }
  },

  watch: {
    show: function(val) {
      if (val && this.oneLoading) {
        // 给个延迟，保证能够正确计算rem值
        setTimeout(() => {
          this.initIScroll();
          this.oneLoading = false;
        },20)
      }
    }
  },

  data() {
    return {
      oneLoading: true,
      retDate: {},
      isSure: false,
      isShow: this.show,
      Scroll: [], // [年，月，日，时] 的滚动对象
      IsScroll: [false, false, false], // [年，月，日] 是否处于滚动状态
      ForbiddenToSwitch: false, //禁止切换
      years: [],
      months: [],
      monthsStr: [],
      days: [],
      daysStr: [],
      hours: ['时辰不清楚'],
      islDate: false,
      selectDate: [1990,1,1,'时辰不清楚'],
      itemHeight: (document.body.offsetWidth / 750) * 100 * 0.8
    }
  },

  created() {
    this.initDate()
    setTimeout(() => {
      if(this.defaultdate) {
        let temp_arr = this.defaultdate.split(' ')
        let date = temp_arr[0].split('-')
        this.selectDate = [parseInt(date[0]), parseInt(date[1]), parseInt(date[2]), this.defaulthour]
        if(this.defaultwhich == '农历') {
          this.islDate = true
        }
        this.getRetDate()
        this.sureTime()
      }
    }, 1000)
  },

  methods: {
    /**
      * @func
      * @dosc 初始化Scroll，(document.body.offsetWidth / 750) * 100 * 0.8 = 40px（在iphone6尺寸下），单个选项的高度
      *
      */
    initIScroll() {

      let _this = this
      let year_y = _this.itemHeight * -50
      let yearScroll = new IScroll('years', {
        snap: "li",
        hideScrollbar: true,
        hScroll: false,
        vScroll: true,
        hScrollbar: false,
        vScrollbar: false,
        y: year_y,
        onScrollStart () {
          _this.IsScroll[0] = true
        },
        onScrollEnd() {
          if (!_this.IsScroll[0]) {
            return 0;
          }
          _this.IsScroll[0] = false
          let index = Math.round(Math.abs(this.y / _this.itemHeight)),
              nowMonth = _this.months.indexOf(_this.selectDate[1]);
          _this.selectDate[0] = _this.years[index];

          _this.correctDate(_this.selectDate[0], _this.selectDate[1], _this.selectDate[2])
            .then(() => {
              if (_this.islDate) {
                _this.setRunYue(_this.selectDate[0]).then(() => {
                  // 从润月到非润月，月数少一天，如果在润年选择了12月，nowMonth会取不到，直接设置11即可。
                  _this.selectDate[1] = _this.months[nowMonth] || _this.months[11]

                  _this.correctDate(_this.selectDate[0], _this.selectDate[1], _this.selectDate[2])
                    .then(() => {
                      if (_this.selectDate[1].toString().indexOf('闰') == -1) {
                        _this.setDays(_this.selectDate[0], _this.selectDate[1], 1)
                        } else {
                        _this.setRunYueDays(_this.selectDate[0], _this.selectDate[1], 1)
                      }
                    })
                })
              } else {
                _this.setDays(_this.selectDate[0], _this.selectDate[1], 1)
              }
            })
        }
      });
      let nYearIndex = this.years.findIndex((i) => i == this.selectDate[0])
      yearScroll.scrollTo(0, -this.itemHeight * nYearIndex)

      let monthScroll = new IScroll('months', {
        snap: "li",
        hideScrollbar: true,
        hScroll: false,
        vScroll: true,
        hScrollbar: false,
        vScrollbar: false,
        y: -0,
        onScrollStart () {
          _this.IsScroll[1] = true
        },
        onScrollEnd() {
          if (!_this.IsScroll[1]) {
            return 0;
          }
          _this.IsScroll[1] = false
          let index = Math.round(Math.abs(this.y / _this.itemHeight))
          _this.selectDate[1] = _this.months[index]
          _this.correctDate(_this.selectDate[0], _this.selectDate[1], _this.selectDate[2])
            .then(() => {
              if (_this.selectDate[1].toString().indexOf('闰') !== -1) {
                _this.setRunYueDays(_this.selectDate[0], _this.selectDate[1], 1)
              } else {
                _this.setDays(_this.selectDate[0], _this.selectDate[1],1)
              }
            })
        }
      });
      let nMonthIndex = this.months.findIndex((i) => i == this.selectDate[1])
      monthScroll.scrollTo(0, -this.itemHeight * nMonthIndex)

      let dayScroll = new IScroll('days', {
        snap: "li",
        hideScrollbar: true,
        hScroll: false,
        vScroll: true,
        hScrollbar: false,
        vScrollbar: false,
        y: -0,
        onScrollStart () {
          _this.IsScroll[2] = true
        },
        onScrollEnd() {
          if (!_this.IsScroll[2]) {
            return 0;
          }
          _this.IsScroll[2] = false
          let index = Math.round(Math.abs(this.y / _this.itemHeight))
          _this.selectDate[2] = _this.days[index]
          _this.correctDate(_this.selectDate[0], _this.selectDate[1], _this.selectDate[2])
        }
      });
      let nDayIndex = this.days.findIndex((i) => i == this.selectDate[2])
      dayScroll.scrollTo(0, -this.itemHeight * nDayIndex)

      let hourScroll = new IScroll('hours', {
        snap: "li",
        hideScrollbar: true,
        hScroll: false,
        vScroll: true,
        hScrollbar: false,
        vScrollbar: false,
        y: -0,
        onScrollEnd() {
          let index = Math.round(Math.abs(this.y / _this.itemHeight))
          _this.selectDate[3] = _this.hours[index]
        }
      });
      let nHourIndex = this.hours.findIndex((i) => i == this.selectDate[3])
      hourScroll.scrollTo(0, -this.itemHeight * nHourIndex)

      _this.Scroll = [yearScroll,monthScroll,dayScroll,hourScroll]

      // 滚动过程中，用户点击造成滚动停止时，有可能选项不会对齐，alignment函数修复该问题。
      document.getElementById("years").onclick=()=>{this.alignment(yearScroll)}
      document.getElementById("months").onclick=()=>{this.alignment(monthScroll)}
      document.getElementById("days").onclick=()=>{this.alignment(dayScroll)}
      document.getElementById("hours").onclick=()=>{this.alignment(hourScroll)}
      
      if(this.islDate) {
        this.uselDate()
      }
    },

    // 初始化时间
    initDate() {
      let zhi = ["子", "丑", "寅", "卯", "辰", "巳", "午", "未", "申", "酉", "戌", "亥"]
      for (let i = 1940; i <= new Date().getFullYear(); i++) {
        this.years.push(i)
      }

      for (let i = 1; i <=12; i++) {
        this.months.push(i)
      }

      for (let i = 1; i <= 30; i++) {
        this.days.push(i)
      }

      for (let i = 0; i <= 23; i++) {
        if (i == 23) {
          this.hours.push(`${i}点子时`)
        } else {
          this.hours.push(`${i}点${zhi[Math.ceil(i / 2)]}时`)
        }
      }
    },

    // 用户点公历
    usenDate() {
      if (!this.islDate || this.ForbiddenToSwitch) {
        return 0;
      }

      if (this.IsScroll[0] || this.IsScroll[1] || this.IsScroll[2]) {
        return 0
      }

      this.setDay();
      this.islDate = false;
      this.ForbiddenToSwitch = true;

      let runyue = this.selectDate[1].indexOf ? true : false,
          y = this.selectDate[0],
          m = this.selectDate[1].indexOf ? this.selectDate[1].split('闰')[1] : this.selectDate[1],
          d = this.selectDate[2],
          month = [],
          nDate = calendar.lunar2solar(y,m,d,runyue),
          nYear = nDate.cYear,
          nMonth = nDate.cMonth,
          nDay = nDate.cDay;

      for(let i = 1; i <= 12; i++) {
        month.push(i)
      }
      this.months = month;
      setTimeout(() => {
        this.Scroll[1].refresh()
      },30)
      /**
        * 农历切换到公历，必须等待天数计算完毕再滚动到对应的公历天数。
        * 例如农历只有30天，但是公历有31天，如果天数未计算完毕就进行切换，30数组里找31，返回 -1， -（-1）= 1，公历会变成1号
        */
      this.setDays(nYear,nMonth).then(() => {
        let nYearIndex = -(this.years.indexOf(nYear)),
            nMonthIndex = -(this.months.indexOf(nMonth)),
            nDayIndex = -(this.days.indexOf(nDay));

        this.Scroll[0].scrollTo(0, this.itemHeight * nYearIndex)
        this.Scroll[1].scrollTo(0, this.itemHeight * nMonthIndex)
        this.Scroll[2].scrollTo(0, this.itemHeight * nDayIndex)

        this.selectDate[0] = nYear;
        this.selectDate[1] = nMonth;
        this.selectDate[2] = nDay;
      }).then(() => {
        this.ForbiddenToSwitch = false;
      })
    },

    // 用户点农历
    uselDate() {
      if (this.islDate && this.ForbiddenToSwitch) {
        return 0;
      }

      if (this.IsScroll[0] || this.IsScroll[1] || this.IsScroll[2]) {
        return 0
      }

      this.setDay();
      this.islDate = true;
      this.ForbiddenToSwitch = true;

      let y = this.selectDate[0],
          m = this.selectDate[1],
          d = this.selectDate[2],
          lDate = calendar.solar2lunar(y,m,d),
          lYear = lDate.lYear,
          lMonth = lDate.lMonth,
          lDay = lDate.lDay,
          runyue = calendar.leapMonth(lYear),
          nongliMonthStr = [];

      for (let i = 1; i <= 12; i++) {
        nongliMonthStr.push(calendar.toChinaMonth(i))
      }

      if (runyue !== 0) {
        nongliMonthStr.splice(runyue, 0, `闰${calendar.toChinaMonth(runyue)}`)
        this.months.splice(runyue, 0, `闰${runyue}`)
      }

      this.monthsStr = nongliMonthStr;

      setTimeout(() => {
        this.Scroll[1].refresh()
      },30)

      /**
        * 必须等待天数计算完毕再滚动到对应的天数。
        */
      if (lDate.isLeap) {

        this.setRunYueDays(lYear,lMonth).then(() => {
          let lYearIndex = -(this.years.indexOf(lYear)),
            lMonthIndex = -(this.months.indexOf(lDate.isLeap ? `闰${lMonth}` : lMonth)),
            lDayIndex = -(this.days.indexOf(lDay));

          this.Scroll[0].scrollTo(0, this.itemHeight * lYearIndex)
          this.Scroll[1].scrollTo(0, this.itemHeight * lMonthIndex)
          this.Scroll[2].scrollTo(0, this.itemHeight * lDayIndex)

          this.selectDate[0] = lYear;
          this.selectDate[1] = lDate.isLeap ? `闰${lMonth}` : lMonth;
          this.selectDate[2] = lDay;
        })
        .then(() => {
          this.ForbiddenToSwitch = false;
        })

      } else {

        this.setDays(lYear,lMonth).then(() => {
          let lYearIndex = -(this.years.indexOf(lYear)),
              lMonthIndex = -(this.months.indexOf(lDate.isLeap ? `闰${lMonth}` : lMonth)),
              lDayIndex = -(this.days.indexOf(lDay));

          this.Scroll[0].scrollTo(0, this.itemHeight * lYearIndex)
          this.Scroll[1].scrollTo(0, this.itemHeight * lMonthIndex)
          this.Scroll[2].scrollTo(0, this.itemHeight * lDayIndex)

          this.selectDate[0] = lYear;
          this.selectDate[1] = lDate.isLeap ? `闰${lMonth}` : lMonth;
          this.selectDate[2] = lDay;

        })
        .then(() => {
          this.ForbiddenToSwitch = false;
        })
      }

    },

    // 设置闰月
    setRunYue(y) {
      return new Promise((resolve, reject) => {
        let runyue = calendar.leapMonth(y),
          nongliMonthStr = [],
          months = [];

        for (let i = 1; i <= 12; i++) {
          nongliMonthStr.push(calendar.toChinaMonth(i))
          months.push(i)
        }

        if (runyue !== 0) {
          nongliMonthStr.splice(runyue, 0, `闰${calendar.toChinaMonth(runyue)}`)
          months.splice(runyue, 0, `闰${runyue}`)
        }

        this.monthsStr = nongliMonthStr;
        this.months = months;

        setTimeout(() => {
          this.Scroll[1].refresh()
          resolve()
        },30)
      })
    },

    // 设置润月的天数
    setRunYueDays(y, m, type) {
      return new Promise((resolve, reject) => {
        let monthsDays = calendar.leapDays(y),
            Days = [],
            nongliDayStr = [];

        // 修正，如果选择的‘日’大于当前月总天数，则选择的‘日’自动更正为当前月最大日
        if (type === 1) {
          if (monthsDays < this.selectDate[2]) {
            this.selectDate[2] = monthsDays
          }
        }

        for(let x = 1; x <= monthsDays; x++) {
          Days.push(x)
        }

        for (let i = 1; i <= monthsDays; i++) {
          nongliDayStr.push(calendar.toChinaDay(i))
        }

        this.daysStr = nongliDayStr;
        this.days = Days

        // dom高度变化，安全的重绘页面，iScroll重新计算元素大小
        setTimeout(() => {
          this.Scroll[2].refresh()
          resolve()
        },30)
      })
    },

    /**
      * 计算当前年月的天数
      * 年 or 月滚动结束 or 公农切换时，计算当前年月的天数
      * 年 or 月滚动触发时，selectDate[2]（当前选择的日期）不会变，如果当前月总天数小于之前选择的天数，转换到农历会出错。
      * @func
      * @param {Number} y 年
      * @param {Number} m 月
      * @param {Number} [type] 如果是年 or 月滚动触发，传入1即可，年月变化可能导致当月总天数变小。
      */
    setDays(y,m,type) {
      // 天数重绘，当前选择天数大于当月天数时，可能会滚动。

      return new Promise((resolve, reject) => {
        let monthsDays,
            Days = [],
            nongliDayStr = [];


        if (this.islDate) {
          monthsDays = calendar.monthDays(y,m);
        } else {
          monthsDays = calendar.solarDays(y,m);
        }

        // 修正，如果选择的‘日’大于当前月总天数，则选择的‘日’自动更正为当前月最大日
        if (type === 1) {
          if (monthsDays < this.selectDate[2]) {
            this.selectDate[2] = monthsDays
          }
        }

        for(let x = 1; x <= monthsDays; x++) {
          Days.push(x)
        }

        for (let i = 1; i <= monthsDays; i++) {
          nongliDayStr.push(calendar.toChinaDay(i))
        }

        this.daysStr = nongliDayStr;
        this.days = Days

        // dom高度变化，安全的重绘页面，iScroll重新计算元素大小
        setTimeout(() => {
          this.Scroll[2].refresh()
          resolve()
        },30)
      })

    },

    // fix 2019/9/5 在sure里拿取最终的滚动信息，详见script头部的 fix 2019/9/5
    setDay() {
      let index = Math.round(Math.abs(this.Scroll[2].y / this.itemHeight))
      this.selectDate[2] = this.days[index]
    },

    sure() {
      console.log(this.selectDate)
      if(!this.islDate && this.selectDate[0] <= 1940 && (this.selectDate[1] < 2 || (this.selectDate[1] == 2 && this.selectDate[2] < 8))) {
        this.$Glb.PlMessage('未起大运，请重选出生日期', 1000)
        return
      }
      if(this.IsScroll[0] || this.IsScroll[1] || this.IsScroll[2]) {
        return 0;
      }

      this.setDay()
      this.getSelfRetDate()
      this.isSure = true;

    },
    getSelfRetDate() {
      let retDate = {},
          y = this.selectDate[0] < 1940 ? 1940:this.selectDate[0],
          m = this.selectDate[1],
          d = this.selectDate[2],
          h = this.selectDate[3],
          runyue = this.selectDate[1].indexOf ? true : false;

      if (this.islDate) {
        if (runyue) {
          m = this.selectDate[1].split('闰')[1];
        }

        retDate = calendar.lunar2solar(y,m,d,runyue);

      } else {
        retDate = calendar.solar2lunar(y,m,d);
      }


      retDate.hour = h;

      delete retDate.astro;
      delete retDate.gzDay;
      delete retDate.gzMonth;
      delete retDate.gzYear;
      delete retDate.Term;
      delete retDate.Animal;
      delete retDate.isTerm;
      delete retDate.isToday;
      this.retDate = retDate;
    },
    getRetDate() {
      let retDate = {},
          y = this.selectDate[0],
          m = this.selectDate[1],
          d = this.selectDate[2],
          h = this.selectDate[3]

      retDate = calendar.solar2lunar(y,m,d);


      retDate.hour = h;

      delete retDate.astro;
      delete retDate.gzDay;
      delete retDate.gzMonth;
      delete retDate.gzYear;
      delete retDate.Term;
      delete retDate.Animal;
      delete retDate.isTerm;
      delete retDate.isToday;
      this.retDate = retDate;
    },

    sureTime () {
      // retDate { IDayCn廿七, IMonthCn冬月, cDay1, cMonth1, cYear1992, hour时辰不清楚, isLeap布尔, lDay27, lYear1991, nWeek3, ncWeek星期三 }
      this.$emit('confirm',{
        date: this.retDate,
        nopoint: this.retDate.hour === '时辰不清楚' ? 1 : 0,
        selectType: this.islDate ? '农历' : '公历'
      })
      console.log(this.retDate)
      this.isSure = false;
    },

    /**
      * 矫正滚动位置
    */
    alignment(obj) {
      var currentP = obj.y;
      if(currentP % this.itemHeight === 0) {
        // 当前滚动位置没有问题
      }else {
          var correctP = parseInt(currentP) - parseInt(currentP) % this.itemHeight;
          obj.scrollTo(0, correctP, 200);
      }
    },

    /**
    * 矫正选中日期
    * 公历最小日期为1901年1月1日，农历最小日期为1900年11月11日
    * 公历最大日期为2100年12月31日，农历最大日期为2100年12月1日
    * 超出范围将自动矫正到最近的合法日期
    */
    correctDate(y,m,d) {
      let nDateMinYear = 1901;
      let nDateMinYearIndex = this.years.indexOf(nDateMinYear);
      let selectItemHeight = this.itemHeight;
      return new Promise((resolve, reject) => {
        if (this.islDate) {
          // 农历边界处理

          // 最大日期处理
          if (y == 2100 && m == 12 && d > 1) {
            this.selectDate[2] = 1;
            this.Scroll[2].scrollTo(0, selectItemHeight * 0)
          }

          // 最小日期处理
          if (y == 1900 && m <= 11) {
            this.selectDate[1] = 11;
            this.Scroll[1].scrollTo(0, selectItemHeight * -11)

            if (d < 11) {
              this.selectDate[2] = 11;
              this.Scroll[2].scrollTo(0, selectItemHeight * -10)
            }
          }

        } else {
          // 公历边界处理，超出最小日期
          if (y < nDateMinYear) {
            this.selectDate[0] = nDateMinYear;
            this.Scroll[0].scrollTo(0, selectItemHeight * -nDateMinYearIndex)
          }
        }

        resolve()
      })

    }

  }
}



// WEBPACK FOOTER //
// ./src/components/calendar_2019.vue